<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <graph-tool-bar :showSource="false" @on-selected="onPanelSelect" :dateRangeMenu="false"></graph-tool-bar>
    </div>
    <br />

    <div class="md-layout-item mx-auto md-xsmall-size-100 md-small-size-100 md-medium-size-80 md-large-size-70 md-xlarge-size-60">
      <simple-wizard
        :prevButtonText="$lang.keys.back"
        :nextButtonText="$lang.keys.next"
        :finishButtonText="$lang.keys.save"
        ref="wizard"
      >
        <template slot="header">
          <h3 class="title">Add meter</h3>
          <!-- <h5 class="category"></h5>-->
        </template>

        <wizard-tab :before-change="() => validateStep('step1')">
          <template slot="label">1/4</template>
          <first-step ref="step1" @on-validated="onStepValidated"></first-step>
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('step2')">
          <template slot="label">2/4</template>
          <second-step ref="step2" @on-validated="onStepValidated"></second-step>
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('step3')">
          <template slot="label">3/4</template>
          <third-step ref="step3" @on-validated="onStepValidated"></third-step>
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('step4')">
          <template slot="label">4/4</template>
          <fourth-step ref="step4" @on-validated="onStepValidated"></fourth-step>
        </wizard-tab>
      </simple-wizard>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>



<script>
import graphToolBar from "@/components/GraphToolBar";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";
import snackBar from "@/components/SnackBar";

import axios from "axios";
import format from "date-fns/format";
import Swal from "sweetalert2";

import FirstStep from "./WizardFirstStep";
import SecondStep from "./WizardSecondStep";
import ThirdStep from "./WizardThirdStep";
import FourthStep from "./WizardFourthStep";
import { SimpleWizard, WizardTab } from "@/components";

export default {
  components: {
    graphToolBar,
    snackBar,
    SimpleWizard,
    WizardTab,
    FirstStep,
    SecondStep,
    ThirdStep,
    FourthStep
  },
  data() {
    return {
      selected: {
        device: {}
      },
      wizardModel: {}
    };
  },
  computed: {
    deviceList() {
      return this.$store.getters.getDeviceList;
    }
  },
  methods: {
    validateStep(ref) {
      const validation = this.$refs[ref].validate();
      return validation;
    },

    onStepValidated(validated, model, finish) {
      this.wizardModel = { ...this.wizardModel, ...model };
      if (finish) {
        Swal.fire({
          title: "Uploading...",
          text: "Please wait",
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false
        });

        this.saveMeter().then(response => {
          if (response > 0) {
            this.saveImages(this.wizardModel.images, response).then(res => {
              if (res) {
                //success restart wizard and go to start
                this.$refs.step1.restartToDefault();
                this.$refs.step2.restartToDefault();
                this.$refs.step3.restartToDefault();
                this.$refs.step4.restartToDefault();

                this.$refs.wizard.navigateToTab(0);
                this.$refs.wizard.tabs.forEach(tab => {
                  if (tab.tabId != 0) {
                    tab.checked = false;
                  }
                });
              }
            });
          }
        });
      }
    },

    onPanelSelect(data) {
      this.selected = data;
    },

    getStatus() {
      try {
        if (
          this.deviceList[
            this.deviceList.findIndex(e => e.mac == this.selected.device.mac)
          ].status == "ONLINE"
        ) {
          return 1;
        } else {
          return 0;
        }
      } catch (err) {
        return 0;
      }
    },

    saveImages(images, meter_ID) {
      return new Promise(async (resolve, reject) => {
        const formData = new FormData();
        formData.append(
          "device_token",
          getSelectedDeviceToken(this.selected.device.mac)
        );

        formData.append("meter_ID", meter_ID);

        for (const i of Object.keys(images)) {
          formData.append("images", images[i]);
        }

        axios
          .post(this.$ENDPOINTS.API_W + "/applied-precision/images", formData)
          .then(res => {
            Swal.fire({
              title: this.$lang.messages.success,
              text: "Success saved meters data",
              type: "success",
              confirmButtonClass: "md-button md-success",
              confirmButtonText: this.$lang.keys.close,
              buttonsStyling: false,
              timer: 2000
            });
            resolve(1);
          })
          .catch(err => {
            Swal.fire({
              title: this.$lang.messages.error,
              text: this.$lang.messages.api_communication_error,
              type: "error",
              confirmButtonClass: "md-button md-warning",
              confirmButtonText: this.$lang.keys.close,
              buttonsStyling: false
            });
            resolve(0);
          });
      });
    },

    saveMeter() {
      return new Promise(async (resolve, reject) => {
        const meterData = {
          IDN: "",
          CRC: 0,
          SNUM: this.wizardModel.serial_number,
          TYPE: this.wizardModel.type,
          LPCOUNT: "",
          MTIME: format(new Date(), "X"),
          PRODUCER: this.wizardModel.producer,
          YMAN: this.wizardModel.year,
          VOLTAGE: this.wizardModel.protocol_voltage,
          CURRENT: this.wizardModel.protocol_current,
          CONSTANT: this.wizardModel.constant,
          CONSTUNIT: this.wizardModel.constant_unit,
          SCALEFACTOR: "",
          CLASS: this.wizardModel.class,
          MENERGYTYPE: this.wizardModel.energy,
          FREQ: this.wizardModel.freqeuency,
          CONTYPE: this.wizardModel.constant_type,
          CUSTOMER: this.wizardModel.customer,
          AREA: this.wizardModel.area,
          LOCATION: this.wizardModel.location,
          ADDRESS: this.wizardModel.address,
          CTRATIO: this.wizardModel.CT_ratio,
          VTRATIO: this.wizardModel.VT_ratio,
          NOTE1: this.wizardModel.note1,
          NOTE2: this.wizardModel.note2,
          NOTE3: this.wizardModel.note3,
          NOTE4: this.wizardModel.note4,
          ELM_OUTPUT_TYPE: "",
          IMIN: this.wizardModel.I_min.primary,
          INOM: this.wizardModel.I_nom.primary,
          IMAX: this.wizardModel.I_max.primary,
          UNOM: this.wizardModel.U_nom.primary,
          SQRT3: "",
          CONSTTYPE: this.wizardModel.constant_type,
          ISIDE: "",
          USIDE: "",
          DIALREG: "",
          ENERMETHOD: this.wizardModel.methode,
          CTSNOM: this.wizardModel.CT_snom,
          VTSNOM: this.wizardModel.VT_snom
        };

        axios({
          method: "POST",
          url: this.$ENDPOINTS.API_W + "/applied-precision/meters/add",
          data: {
            device_token: getSelectedDeviceToken(this.selected.device.mac),
            meter: meterData
          },
          withCredentials: true
        })
          .then(response => {
            resolve(response.data.data.ID_meter);
          })
          .catch(error => {
            let errorMsg = "";
            if (error.response.data.code === 529) {
              errorMsg = "Device is offline";
            } else {
              errorMsg = this.$lang.messages.api_communication_error;
            }

            Swal.fire({
              title: this.$lang.messages.error,
              text: errorMsg,
              type: "error",
              confirmButtonClass: "md-button md-warning",
              confirmButtonText: this.$lang.keys.close,
              buttonsStyling: false
            });

            resolve(0);
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.md-toolbar {
  position: inherit;
}
</style>